import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManufacturersList = _resolveComponent("ManufacturersList")!
  const _component_AddManufacturer = _resolveComponent("AddManufacturer")!
  const _component_EditManufacturer = _resolveComponent("EditManufacturer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_ManufacturersList)
    ]),
    _createVNode(_component_AddManufacturer),
    _createVNode(_component_EditManufacturer)
  ], 64))
}